import LoadingLayout from "../../components/layouts/LoadingLayout";
import ProtectedRoute from "../utils/ProtectedRoute";
import RequireRole from "../utils/RequireRole";


export const LoadingManager = [
  {
    path: "/loading/",
    element: (
      <ProtectedRoute>
        <RequireRole allowedRoles={["loading_manager"]}>
          <LoadingLayout>
            <h1 className="text-2xl font-bold">Loading Manager</h1>
          </LoadingLayout>
        </RequireRole>
      </ProtectedRoute>
    ),
  },
];
